import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="trail-form"
export default class extends Controller {
  static targets = [
    "ordering",
    "requiredStepCountField",
    "completionAwardCheckbox",
    "completionAwardFields",
    "name",
    "completionAwardKey"
  ]

  connect() {
    this.update()

    // Only auto-sync the key while it still matches what we'd derive from
    // the current name (covers a blank key on a new record, and a key that
    // was left at its auto-derived value on an existing one) - an admin who
    // has actually customised it should never have that overwritten.
    if (this.hasCompletionAwardKeyTarget) {
      this.keyEditedManually = this.completionAwardKeyTarget.value !== this.slugify(this.nameTarget.value)
    }
  }

  update() {
    const isAnyOrder = this.orderingTarget.value === "any_order"
    this.requiredStepCountFieldTarget.classList.toggle("hidden", !isAnyOrder)
    this.requiredStepCountFieldTarget.querySelectorAll("input").forEach(input => { input.disabled = !isAnyOrder })

    this.completionAwardFieldsTarget.classList.toggle("hidden", !this.completionAwardCheckboxTarget.checked)
  }

  syncCompletionAwardKey() {
    if (this.keyEditedManually) return

    this.completionAwardKeyTarget.value = this.slugify(this.nameTarget.value)
  }

  markCompletionAwardKeyEdited() {
    this.keyEditedManually = true
  }

  slugify(value) {
    return value.toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")
  }
}
